import { CandidatePayload } from './types';

// Снапшот релевантности из ответа relevanter-back (aiRating/aiComment/matchLevel)
// кладём рядом с кандидатом. Бэк сохранит в campaign_candidates, фронт отрисует в диалоге.
export function buildRelevanceFields(candidate: Record<string, unknown>): Partial<CandidatePayload> {
  const rating = candidate.aiRating;
  const score = typeof rating === 'number' && Number.isFinite(rating) ? Math.round(rating) : null;
  const matchLevel = typeof candidate.matchLevel === 'string' ? candidate.matchLevel : null;
  const feedback = serializeAiComment(candidate.aiComment);

  if (score === null && matchLevel === null && feedback === null) {
    return {};
  }

  return {
    relevanceScore: score,
    relevanceMatchLevel: matchLevel,
    relevanceFeedback: feedback,
  };
}

function serializeAiComment(comment: unknown): string | null {
  if (comment === null || comment === undefined) return null;
  if (typeof comment === 'string') return comment;
  try {
    return JSON.stringify(comment);
  } catch {
    return null;
  }
}

// TASKNEIROKLYUCH-728: для откликов API возвращает плоскую структуру
// { rating, comment: string, positiveFacts, negativeFacts }, а в холодном
// поиске aiComment уже приходит как объект { summary, positiveFacts, negativeFacts }.
// Чтобы снапшот в campaign_candidates был одинаковым для обоих источников
// (и RelevanceBlock рисовал плюсы/минусы), собираем тут aiComment-объект.
export function evaluationToRelevanceInput(evaluation: any): Record<string, unknown> | null {
  if (!evaluation || typeof evaluation !== 'object') return null;

  const rating = typeof evaluation.rating === 'number' ? evaluation.rating : null;
  const summary = typeof evaluation.comment === 'string' ? evaluation.comment : '';
  const positiveFacts = Array.isArray(evaluation.positiveFacts) ? evaluation.positiveFacts : [];
  const negativeFacts = Array.isArray(evaluation.negativeFacts) ? evaluation.negativeFacts : [];

  const hasStructured = positiveFacts.length > 0 || negativeFacts.length > 0;
  // Если есть структурированные факты — оборачиваем в объект, чтобы JSON.stringify
  // в buildRelevanceFields сериализовал summary+positiveFacts+negativeFacts.
  // Если фактов нет — оставляем строку summary, чтобы не плодить пустые JSON.
  const aiComment = hasStructured
    ? { summary, positiveFacts, negativeFacts }
    : (summary || null);

  // matchLevel в evaluation для откликов отсутствует — вычисляем по тем же
  // порогам, что и cold-search (см. routes/hh.js: 85/70).
  const matchLevel = typeof evaluation.matchLevel === 'string'
    ? evaluation.matchLevel
    : (rating !== null ? (rating >= 85 ? 'high' : rating >= 70 ? 'medium' : 'low') : null);

  return {
    aiRating: rating,
    aiComment,
    matchLevel,
  };
}
